import React from "react";
import { Icon, Card, CardDescription } from "semantic-ui-react";
import { definedRouteTypes } from "api/api";
import { useTranslation } from "react-i18next";

import LinkCard, { ILinkCardProps } from "./LinkCard";

import { INewsDisplay } from "../../../api/types/NewsEntity";
import EventImage, {
  IEventImageProps,
  definedAspectRatios,
} from "../Images/EventImage/EventImage";
import Typography, {
  definedTypography,
} from "../../atoms/Typography/Typography";
import EventDetailList, {
  IEventDetailListProps,
} from "../List/EventDetailList";
import { styledWithTheme } from "../../../styles/theme";
import { getThumbnailLink } from "../../../helpers/globalFunctions";
import { PLACEHOLDER_16_TO_9 } from "../../../images/imageSources";
import TildeTranslate from "../../atoms/Text/TildeTranslate";

interface EventMapCardProps {
  event: INewsDisplay;
  route?: string;
  onCardClose?: any;
}
const StyledCardClose = styledWithTheme.div(({ theme }) => ({
  marginTop: "0.5em",
  display: "flex",
  justifyContent: "flex-end",

  i: {
    color: theme.palette.mono.light,
    cursor: "pointer",
    fontSize: "1.5rem",
  },
}));

const StyledLinkCard = styledWithTheme.div(({ theme }) => ({
  backgroundColor: theme.palette.mono.white,
}));
const EventMapCard: React.FC<EventMapCardProps> = ({
  route,
  event,
  onCardClose,
}) => {
  const { t } = useTranslation();
  const cardProps: Partial<ILinkCardProps> = {};
  const imageProps: Partial<IEventImageProps> = {};
  const detailProps: Partial<IEventDetailListProps> = {};
  const {
    slug,
    imageUrl,
    dateFrom,
    dateTo,
    organizationInfo,
    toBePostedAt,
    countries,
    address,
    customLabel,
    category,
    title,
    type,
  } = event;
  const alignText = "center";

  cardProps.hover = false;
  cardProps.width = "20em";
  cardProps.textAlign = alignText;
  detailProps.date = toBePostedAt;
  detailProps.countries = countries;
  detailProps.locationInfo = address;
  imageProps.dateFrom = dateFrom;
  imageProps.dateTo = dateTo;
  detailProps.date = dateFrom;
  detailProps.organization = organizationInfo?.title;
  imageProps.size = "tiny";
  imageProps.aspectRatio = definedAspectRatios.aspect16to9;

  imageProps.label = customLabel;
  if (customLabel) {
    imageProps.label = customLabel;
  } else if (type === definedRouteTypes.events && category) {
    imageProps.label = t(`keyword:${category}`);
  } else if (type === definedRouteTypes.organizations && category) {
    imageProps.label = t(`keyword:${category}`);
  } else if (type === definedRouteTypes.organizationNews) {
    imageProps.label = organizationInfo?.title || t("OrganisationContent");
  }

  imageProps.imageUrl = PLACEHOLDER_16_TO_9;
  if (imageUrl) {
    imageProps.imageUrl = getThumbnailLink(imageUrl);
  }

  return (
    <>
      <StyledCardClose>
        <Icon name="times circle outline" onClick={onCardClose} />
      </StyledCardClose>
      <LinkCard
        route={`/${route}/${slug}`}
        newTab
        {...cardProps}
        id={slug}
        title={title}
      >
        <StyledLinkCard>
          <EventImage {...imageProps} />
          <Card.Content>
            <Card.Header>
              <Typography align={alignText} type={definedTypography.h3}>
                <TildeTranslate text={event.title} />
              </Typography>
            </Card.Header>
            <CardDescription>
              <EventDetailList {...detailProps} />
            </CardDescription>
          </Card.Content>
        </StyledLinkCard>
      </LinkCard>
    </>
  );
};

export default EventMapCard;
